import { baseApi, select, insert, update, afterInsert, beforeUpdate } from './base';

import { revisionListType, revisionDiffType } from '../graphqlTypes';

const revisionApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getRevisions: select(builder, 'revision', revisionListType, false, {
      filter: (params) => `{sheet_id: {_eq: ${params.sheetId}}}`,
      order: `{created_at: desc}`,
    }),
    insertRevision: insert(
      builder,
      'revision',
      revisionListType,
      afterInsert('getRevisions'),
      (result, error, arg) => [{ type: 'SheetRow', id: arg.payload.sheet_id.toString() }]
    ),
    updateRevision: update(
      builder,
      'revision',
      revisionListType,
      beforeUpdate('getRevisions', true)
    ),
    getDiffRevisions: select(builder, 'revision', revisionDiffType, false, {
      filter: (params) => `{id: {_in: [${params.revisionIds}]}}`,
      order: `{created_at: asc}`,
      response: (response, meta, arg) =>
        response.revision.map((entry) => ({
          ...entry, // Keep all top-level properties
          sheet_rows: Object.fromEntries(
            Object.entries(entry.sheet_rows).map(([key, row]) => [
              key,
              {
                ...row,
                ...(row.custom || {}), // Merge custom fields into the main object
              },
            ])
          ),
        })),
    }),
  }),
  overrideExisting: false,
});

export const {
  useGetRevisionsQuery,
  useInsertRevisionMutation,
  useUpdateRevisionMutation,
  useGetDiffRevisionsQuery,
} = revisionApi;
